<template>
    <div>
        <div v-if="Number(typeVal) === 1" class="content  content-bg3 tc">
            <img class="banner" src="@/assets/imgs/zl/1.png">
            <div class="pr">
                <!--    菜单  -->
                <ul class="pa">
                    <li v-for="(item,i) in lists" :class="[selectIdx === i && 'checked','flex']" :key="i" @click="handleSwitch(i)">
                        <img v-if="selectIdx === i" class="icon" src="@/assets/imgs/zl/1-i.png">
                        <p>{{item.name}}</p>
                        <img v-if="selectIdx === i" class="icon" src="@/assets/imgs/zl/1-i.png">
                    </li>
                </ul>
                <img class="banner" src="@/assets/imgs/zl/1-1.png">
                <div  class="con">
                    <img v-for="(img, index) in lists[selectIdx].imgs" :key="index" :src="img" />
                </div>
            </div>
        </div>
        <div v-else class="content  content-bg3 tc">
            <img class="banner" src="@/assets/imgs/zl/banner1.png">
            <img class="banner" src="@/assets/imgs/zl/banner2.png">
            <div class="pr">
                <!--    菜单  -->
                <ul class="pa">
                    <li v-for="(item,i) in listsTwo" :class="[selectIdx === i && 'checked','flex']" :key="i" @click="handleSwitch(i)">
                        <img v-if="selectIdx === i" class="icon" src="@/assets/imgs/zl/1-i.png">
                        <p>{{item.name}}</p>
                        <img v-if="selectIdx === i" class="icon" src="@/assets/imgs/zl/1-i.png">
                    </li>
                </ul>
                <div  class="con">
                    <img v-for="(img, index) in  listsTwo[selectIdx].imgs" :key="index" :src="img" />
                </div>
            </div>
        </div>

    </div>
</template>

<script setup>
import {onMounted, ref, watch} from "vue";
    import { useRoute, useRouter } from 'vue-router/composables'
    const route = useRoute()


    const lists = [
        {name:'序言',sort:'1',imgs:[
            require('@/assets/imgs/zl/_1.png'),
            require('@/assets/imgs/zl/_2.png'),
        ]
        },
        {name:'灵秀山水',sort:'2',imgs:[
            require('@/assets/imgs/zl/6@2x.png'),
            require('@/assets/imgs/zl/7@2x.png'),
            require('@/assets/imgs/zl/8@2x.png'),
            require('@/assets/imgs/zl/9@2x.png'),
            require('@/assets/imgs/zl/10@2x.png'),

        ]},
        {name:'远古家园',sort:'3',imgs:[
            require('@/assets/imgs/zl/3-1.png'),
            require('@/assets/imgs/zl/3-2.png'),
        ]},
        {name:'社会融合',sort:'4',imgs:[
            require('@/assets/imgs/zl/4-1.png'),
            require('@/assets/imgs/zl/4-2.png'),
            require('@/assets/imgs/zl/4-3.png'),
            require('@/assets/imgs/zl/4-4.png'),
        ]},
        {name:'商埠文化',sort:'5',imgs:[
            require('@/assets/imgs/zl/5-1.png'),
            require('@/assets/imgs/zl/5-2.png'),
            require('@/assets/imgs/zl/5-3.png'),
            require('@/assets/imgs/zl/5-4.png'),
            require('@/assets/imgs/zl/5-5.png'),
            require('@/assets/imgs/zl/5-6.png'),
        ]},
        {name:'理学文化',sort:'6',imgs:[
            require('@/assets/imgs/zl/6-2.png'),
            require('@/assets/imgs/zl/6-3.png'),
            require('@/assets/imgs/zl/6-4.png'),

            require('@/assets/imgs/zl/6-5.png'),
            require('@/assets/imgs/zl/6-6.png'),
            require('@/assets/imgs/zl/6-1.png'),

            require('@/assets/imgs/zl/6-8.png'),
            require('@/assets/imgs/zl/6-7.png'),
            require('@/assets/imgs/zl/6-9.png'),
            require('@/assets/imgs/zl/6-11.png'),
        ]},
        {name:'乐居文化',sort:'7',imgs:[
            require('@/assets/imgs/zl/7-1.png'),
            require('@/assets/imgs/zl/7-2.png'),
            require('@/assets/imgs/zl/7-3.png'),
            require('@/assets/imgs/zl/7-4.png'),
            require('@/assets/imgs/zl/7-5.png'),
            require('@/assets/imgs/zl/7-6.png'),
            require('@/assets/imgs/zl/7-7.png'),
            require('@/assets/imgs/zl/7-8.png'),
        ]},
        {name:'烽火岁月',sort:'8',imgs:[
            require('@/assets/imgs/zl/8-1.png'),
            require('@/assets/imgs/zl/8-2.png'),
            require('@/assets/imgs/zl/8-3.png'),
            require('@/assets/imgs/zl/8-4.png'),
            require('@/assets/imgs/zl/8-5.png'),
            require('@/assets/imgs/zl/8-6.png'),
            require('@/assets/imgs/zl/8-7.png'),
            require('@/assets/imgs/zl/8-8.png'),
            require('@/assets/imgs/zl/8-9.png'),
            require('@/assets/imgs/zl/8-10.png'),
            require('@/assets/imgs/zl/8-11.png'),
        ]},
    ]
    const listsTwo = [
        {name:'前言',sort:'1',imgs:[
            require('@/assets/imgs/zl/9-1.png'),
            require('@/assets/imgs/zl/9-2.png'),
            require('@/assets/imgs/zl/9-3.png'),
            require('@/assets/imgs/zl/9-4.png'),
            require('@/assets/imgs/zl/9-5.png'),
            require('@/assets/imgs/zl/9-6.png'),
            require('@/assets/imgs/zl/9-7.png'),
            require('@/assets/imgs/zl/9-8.png'),
            require('@/assets/imgs/zl/9-9.png'),
            require('@/assets/imgs/zl/9-10.png'),
            ]
        },
        {name:'西游故事',sort:'2',imgs:[
              require('@/assets/imgs/zl/10-1.png'),
            require('@/assets/imgs/zl/10-2.png'),
            require('@/assets/imgs/zl/10-3.png'),
            require('@/assets/imgs/zl/10-4.png'),
            require('@/assets/imgs/zl/10-5.png'),
            require('@/assets/imgs/zl/10-6.png'),
            require('@/assets/imgs/zl/10-7.png'),
            require('@/assets/imgs/zl/10-8.png'),
            require('@/assets/imgs/zl/10-9.png'),
            require('@/assets/imgs/zl/10-10.png'),

        ]}]
        let typeVal = ref(1)


    let selectIdx=ref(0)
    const handleSwitch=(i)=>{
        selectIdx.value = i
    }
    onMounted(()=>{
        typeVal.value = route.query?.type || 1;
    })


</script>

<style lang="scss" scoped>
.content{
    background:#5ea6a2;
    font-size: 0;
    .banner{
        width: 100%;
    }
    .con{
        // max-width: 1175px;
        // margin: 89px auto 174px;

        img{
            width: 100%;
            height: auto;
            font-size: 0;
            &:last-child{
                margin-top: -1px;
            }
        }
    }

    &.content-bg2{
        background:#c9c4b5;
    }
    &.content-bg3{
        background:#e5e1d9;
    }
    &.content-bg4{
        background:#c4b1b1;
    }
    .con-bg4{
        background:#54545a;
    }

    ul{
        top: 116px;
        left: 0;
        position: absolute;
        li{
            width:304px;
            height:81px;
            text-align: center;
            position: relative;
            margin-bottom: 8px;
            background:#3b322d;
            cursor: pointer;
            justify-content: center;
            align-items: center;
            padding: 0 17px;

            .icon{
                width: 53px;
                height: 53px;
            }

            &.checked{
                background:#164a47;
                color: #d9c7ac;
                justify-content: space-between;
            }

            &:hover{
                background:#164a47;;

                p{
                      color: #d9c7ac;
                }

            }

            p{
                font-weight:700;
                color:#d9c7ac;
                font-size:30px;
                line-height: 81px;
                letter-spacing: 4px;
            }
            i{
                display: block;
                width:20px;
                height:64px;
                border:1px solid #d9c7ac;
                font-style: normal;
                position: absolute;
                left: 10px;
                top: 9px;
                color: #d9c7ac;
                font-size: 12px;
                //line-height: 1;
            }
        }
    }
}
</style>
